import React, { useEffect, useRef, useState } from "react";
import { Tooltip, Box, Typography, IconButton, Button, Grid, CircularProgress } from '@mui/material';
import Card from "../../components/card/Card";
import TableContainer from "../../components/table/table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getReports } from "../../store/actions/report";
import TextAreaFields from "../../components/textAreaFields";
import { useForm } from "react-hook-form";
import ButtonContainer from "../../components/buttonContainer";
import { filterName } from "../../utils/Utils";
import moment from "moment";

const ReportDetail = (props) => {
    const { data, setOpen } = props
    const [isLoading, setIsLoading] = useState(false);
    const [isCommentLoading, setIsCommentLoading] = useState(false);
    const dispatch = useDispatch()
    const [dataList, setDataList] = useState([])
    const [commentsList, setCommentsList] = useState([])

    const { packSizeList, medicationTypeList } = useSelector(state => state.filler)
    const { user } = useSelector(state => state.auth)

    const tableHeader = ['DIN Number', 'Product Name', 'Type of Medication', 'Strenght', 'Requested Quantity', 'Pack Size', 'Product Quantity', 'Comment']
    const verifyParam = ['diN_Master', 'productName', 'dosageValue', 'mg', 'qty', 'packSizeValue', 'productQty', 'comments']


    const defaultValues = useForm({
        defaultValues: {
            comment: "",
        },
    });

    const {
        control,
        handleSubmit,
        setError,
        clearErrors,
        watch,
        reset,
        resetField,
        getValues,
        formState: { errors },
    } = defaultValues;
    useEffect(() => {
        setRequestProductList()
        getComments()
    }, [])

    const scrollRef = useRef(null);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [commentsList]);


    const setRequestProductList = () => {
        let arr = []
        data?.products?.forEach((ele) => {
            const obj = { ...ele }
            obj['dosageValue'] = filterName(medicationTypeList, ele.dosage_ID)
            obj['packSizeValue'] = filterName(packSizeList, ele.packSize_ID)
            arr.push(obj)
        })
        setDataList(arr)
    }

    const getComments = () => {
        setIsLoading(true)
        let obj =
        {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETALLCOMMENTSBYRFID",
            "data": { "RFTS_ID": data?.rftsid, },
            "debug": null,
            "token": null
        }
        dispatch(getReports(obj)).then(res => {
            let comments = res.payload?.data
            setCommentsList(comments)
            setIsLoading(false)
        })
    }

    const addComment = () => {
        setIsCommentLoading(true)
        let obj =
        {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "INSERTRFTSCOMMENTS",
            "data": { "RFTS_ID": data?.rftsid, "CreateBy": user?.userId, 'Comments': watch('comment') },
            "debug": null,
            "token": null
        }
        dispatch(getReports(obj)).then(res => {
            const record = res.payload?.data?.Data[0]
            let arr = [...commentsList]
            arr.push({
                ...record,
                username: user?.userName
            })
            setCommentsList(arr)
            reset({
                comment: "",
            })
            setIsCommentLoading(false)
        })
    }




    return (
        <>
            <Box sx={{ margin: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h1' >Report Detail</Typography>
            </Box>
            <Card style={{ flex: 1, overflow: 'auto' }}>
                <TableContainer tableHeader={tableHeader}
                    data={dataList.filter(val => val.Role !== 'Super Admin')}
                    verifyParam={verifyParam}
                />

                <Box sx={{ margin: '10px 0px' }}>
                    <Box sx={{ padding: '10px', backgroundColor: '#cab2e8' }}>
                        <Typography sx={{ fontSize: '15px', fontWeight: 600 }}>Comments</Typography>
                    </Box>

                    <Box sx={{ border: '2px solid rgb(237, 231, 246)', padding: '0px 10px' }}>
                        {
                            isLoading ? <Box className='tableLoadingContainer'>
                                <CircularProgress size={50} sx={{ margin: '20px' }} />
                            </Box>
                                : <Box ref={scrollRef} sx={{ margin: '10px 0px', maxHeight: '200px', overflow: 'scroll' }}>
                                    {
                                        commentsList?.map(ele => (
                                            <Box sx={{
                                                display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px',
                                                border: '1px solid #eee',
                                                padding: '5px',
                                                margin: '5px',
                                                borderRadius: '5px'
                                            }}>
                                                <Box>
                                                    <Typography sx={{ fontWeight: 600 }}>{ele.username}</Typography>
                                                    <Typography variant="body2">{ele.comments}</Typography>
                                                </Box>
                                                <Typography sx={{ fontSize: '10px', fontWeight: '300' }}>{moment(ele.createdOn).format('DD MMM, h:m a')}</Typography>
                                            </Box>
                                        ))
                                    }
                                </Box>}
                        <Box sx={{ display: 'flex', alignItems: 'start', gap: '10px' }}>
                            <TextAreaFields
                                fieldName="comment"
                                type="text"
                                label="Comment"
                                control={control}
                                rows={2}
                            />
                            <Box sx={{ paddingTop: '10px' }}>
                                <ButtonContainer isSingle>
                                    <Button disabled={isCommentLoading || watch('comment').trim().length == 0} size="medium" variant="contained" color="primary" onClick={handleSubmit(addComment)} >
                                        {isCommentLoading && (
                                            <CircularProgress size={20} sx={{ marginRight: 1, color: "#fff" }} />
                                        )}
                                        Send</Button>
                                </ButtonContainer>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Card>
        </>
    );
};

export default ReportDetail;